import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule, Type, inject, provideAppInitializer } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { FormlyConfig } from "@ngx-formly/core";
import { DragScrollComponent, DragScrollItemDirective } from "ngx-drag-scroll";
import { ContactsModule } from "../../components/contacts/contacts.module";
import { DateModule } from "../../components/date/date.module";
import { GalleryModule } from "../../components/gallery/gallery.module";
import { PipeModule } from "../../pipes/pipes.module";
import { BadgeModule } from "../badge/badge.module";
import { BlankInformationModule } from "../blank-information/blank-information.module";
import { EntitiesModule } from "../entities/entities.module";
import { FilterModule } from "../filter/filter.module";
import { FormModule } from "../forms/form/form.module";
import { HeaderModule } from "../header";
import { ListsModule } from "../lists/lists.module";
import { ModalModule } from "../modal";
import { SelectorModule } from "../selector/selector.module";
import { SlidingListModule } from "../sliding-list/sliding-list.module";
import { SpinnerModule } from "../spinner";
import { VirtualScrollModule } from "../virtual-scroll/virtual-scroll.module";
import { AddDocumentModalComponent } from "./components/add-document-modal/add-document-modal.component";
import { DocExplorerFilterBarComponent } from "./components/doc-explorer-filter-bar/doc-explorer-filter-bar.component";
import { DocExplorerSlideComponent } from "./components/doc-explorer-slide/doc-explorer-slide.component";
import { DocExplorerComponent } from "./components/doc-explorer/doc-explorer.component";
import { DocPickerComponent } from "./components/doc-picker/doc-picker.component";
import { DocumentGalleryFieldComponent } from "./components/document-gallery-field/document-gallery-field.component";
import { DocumentGalleryComponent } from "./components/document-gallery/document-gallery.component";
import { DocumentHeaderComponent } from "./components/document-header/document-header.component";
import { DocumentImagePreviewComponent } from "./components/document-image-preview/document-image-preview.component";
import { DocumentItemSkeletonComponent } from "./components/document-item-skeleton/document-item-skeleton.component";
import { DocumentItemComponent } from "./components/document-item/document-item.component";
import { DocumentListModal } from "./components/document-list-modal/document-list-modal.component";
import { DocumentListComponent } from "./components/document-list/document-list.component";
import { FolderItemComponent } from "./components/folder-item/folder-item.component";
import { FolderListComponent } from "./components/folder-list/folder-list.component";
import { SelectSubFolderModalComponent } from "./components/select-sub-folder-modal/select-sub-folder-modal.component";

const components: Type<any>[] = [
	DocExplorerComponent,
	DocExplorerSlideComponent,
	AddDocumentModalComponent,
	SelectSubFolderModalComponent,
	DocumentListComponent,
	FolderListComponent,
	DocumentItemComponent,
	DocumentItemSkeletonComponent,
	FolderItemComponent,
	DocPickerComponent,
	DocumentHeaderComponent,
	DocExplorerFilterBarComponent,
	DocumentListModal,
	DocumentGalleryComponent,
	DocumentImagePreviewComponent,
	DocumentGalleryFieldComponent
];

@NgModule({
	imports: [
		IonicModule,
		CommonModule,
		VirtualScrollModule,
		ListsModule,
		ScrollingModule,
		ModalModule,
		SelectorModule,
		SpinnerModule,
		SlidingListModule,
		BadgeModule,
		BlankInformationModule,
		EntitiesModule,
		HeaderModule,
		FilterModule,
		DateModule,
		ContactsModule,
		GalleryModule,
		PipeModule,
		DragScrollComponent,
		DragScrollItemDirective,
		FormModule
	],
	exports: components,
	declarations: components,
	providers: [
		provideAppInitializer(() => {
			const initializerFn = ((ioFormlyConfig: FormlyConfig) => () => {
				ioFormlyConfig.addConfig({
					types: [
						{
							name: "document-gallery",
							component: DocumentGalleryFieldComponent,
							defaultOptions: {
								props: {
									disableCopy: true
								}
							}
						}
					]
				});
			})(inject(FormlyConfig));
			return initializerFn();
		})
	]
})
export class DocExplorerModule {}
